import CountriesTable from "./components/CountriesTable";

export default function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <CountriesTable />
    </div>
  );
}
